import { DomainIntentReferral, parseDomain } from '@wix/domains-serverless-interface';
import { EXPRESS_CHECKOUT_BM_APP_ID, EXPRESS_CHECKOUT_BM_SPLIT_PAGE_ID } from '../../../constants';
const GET_DOMAIN_BASE_URL = '//manage.wix.com/get-domain';
const buildUrlWithParams = (baseUrl, params) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(_ref => {
    let key = _ref[0],
      value = _ref[1];
    if (value !== undefined && value !== null) {
      const valueArray = Array.isArray(value) ? value : [value];
      valueArray.forEach(val => {
        searchParams.append(key, String(val));
      });
    }
  });
  const query = searchParams.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
};
export const urls = {
  contactSupportUrl: `/contact/`,
  purchaseDomainUrl: '/wix/api/domainPurchaseStart',
  extendDomainUrl: '/wix/api/domainStartRenew',
  createSitesUrl: '/website/templates',
  dynamicOfferingCheckoutPageUrl: '/dynamic-offering-checkout-page/purchaseSingleProduct',
  conciergeUrl: _ref2 => {
    let msid = _ref2.msid,
      domainName = _ref2.domainName,
      connectFlow = _ref2.connectFlow;
    const baseUrl = `/dashboard/${msid}/add-domain${connectFlow ? '/connect' : ''}`;
    const searchParams = new URLSearchParams();
    if (domainName) {
      searchParams.append('domainName', domainName);
    }
    const query = searchParams.toString();
    return query ? `${baseUrl}?${query}` : baseUrl;
  },
  domainSearchMobileUrl: _ref3 => {
    let metaSiteId = _ref3.metaSiteId,
      domainName = _ref3.domainName;
    return buildUrlWithParams('/_serverless/premium-domains-serverless/domain-search-mobile', {
      metaSiteId,
      domainName
    });
  },
  domainPurchaseBmUrl: _ref4 => {
    let msid = _ref4.msid,
      domainName = _ref4.domainName,
      referrer = _ref4.referrer,
      referralAdditionalInfo = _ref4.referralAdditionalInfo;
    return buildUrlWithParams(`/dashboard/${msid}/add-domain/setup`, {
      referrer,
      domainName,
      referralAdditionalInfo
    });
  },
  getDomainUrl: function (params, flowType) {
    if (flowType === void 0) {
      flowType = 'purchase';
    }
    return buildUrlWithParams(GET_DOMAIN_BASE_URL, {
      ...params,
      flowType
    });
  },
  transferInUrl: params => buildUrlWithParams(GET_DOMAIN_BASE_URL, {
    ...params,
    flowType: 'transfer_in'
  }),
  transferDomainToWix: params => {
    return buildUrlWithParams(`/wix/api/domainTransferInFullFlowPurchaseStart`, params);
  },
  supportArticle: _ref5 => {
    let id = _ref5.id,
      locale = _ref5.locale,
      _ref5$referralAdditio = _ref5.referralAdditionalInfo,
      referralAdditionalInfo = _ref5$referralAdditio === void 0 ? '' : _ref5$referralAdditio;
    return buildUrlWithParams(`//support.wix.com/articles/id/${id}`, {
      locale,
      referralAdditionalInfo
    });
  },
  transferAwaySupport: locale => `/contact/${locale}?subOptionId=Transfer-a-domain-away-from-Wix92758`,
  buyMailbox: params => {
    return buildUrlWithParams(`/store/mailboxPackagePicker`, params);
  },
  turnOnAutoRenewPage: _ref6 => {
    let premiumId = _ref6.premiumId,
      referralAdditionalInfo = _ref6.referralAdditionalInfo;
    return buildUrlWithParams(`/wix/api/mpContainerStaticController`, {
      originWidgetName: 'billings',
      premiumId,
      referralAdditionalInfo
    });
  },
  packagePicker: params => {
    return buildUrlWithParams(`/store/plans`, params);
  },
  manageMailbox: _ref7 => {
    let siteGuid = _ref7.siteGuid,
      domainName = _ref7.domainName,
      referralAdditionalInfo = _ref7.referralAdditionalInfo;
    return siteGuid ? buildUrlWithParams(`/dashboard/${siteGuid}/my-mailboxes-site-level`, {
      domainName,
      referralAdditionalInfo
    }) : buildUrlWithParams(`account/mailboxes`, {
      referralAdditionalInfo
    });
  },
  accountTeamManage: () => {
    return buildUrlWithParams(`/account/team/`, {
      referralAdditionalInfo: 'mydomains'
    });
  },
  packagePickerAsInOldMyDomains: _ref8 => {
    let siteGuid = _ref8.siteGuid,
      referralAdditionalInfo = _ref8.referralAdditionalInfo,
      domainName = _ref8.domainName;
    return buildUrlWithParams('/wix/api/premiumStart', {
      siteGuid,
      referralAdditionalInfo,
      domainName
    });
  },
  searchDomain: _ref9 => {
    let metasiteId = _ref9.metasiteId,
      referralAdditionalInfo = _ref9.referralAdditionalInfo,
      domainName = _ref9.domainName;
    return buildUrlWithParams(`/wix/api/mpContainerStaticController?#/domains`, {
      referralAdditionalInfo: referralAdditionalInfo || 'mydomains__topbutton',
      domainSearch: true,
      accountManager: false,
      siteManager: true,
      domainName,
      metasiteId,
      hasParentApp: true
    });
  },
  editor: _ref0 => {
    let metaSiteId = _ref0.metaSiteId,
      referralAdditionalInfo = _ref0.referralAdditionalInfo,
      editorUrl = _ref0.editorUrl;
    const baseUrl = editorUrl ? editorUrl : '/site-creation-split';
    const params = {};
    if (!editorUrl) {
      params.metaSiteId = metaSiteId;
    }
    if (referralAdditionalInfo) {
      params.referralAdditionalInfo = referralAdditionalInfo;
    }
    return buildUrlWithParams(baseUrl, params);
  },
  extendDomain: (metaSiteId, domainName) => {
    return buildUrlWithParams(`/wix/api/domainStartRenew`, {
      // TODO research should we pass msid into Extend flow (which sounds like no sense)
      // also in all cases we pass site level msid which even not logical for domains in site level
      metaSiteId,
      domainName,
      referralAdditionalInfo: 'mydomains__domaininfotab'
    });
  },
  upgradeSplitPage: async _ref1 => {
    let metaSiteId = _ref1.metaSiteId,
      domainName = _ref1.domainName,
      referralAdditionalInfo = _ref1.referralAdditionalInfo;
    const redirectionFallback = () => {
      const redirectionUrl = buildUrlWithParams(`/dashboard/${metaSiteId}/premium-express-checkout-app/bundle-selection`, {
        domainName,
        referralAdditionalInfo: referralAdditionalInfo || 'domain-search'
      });
      return window.open(redirectionUrl, '_self');
    };
    const canNavigate = await navigateToExpressCheckoutBMApp(EXPRESS_CHECKOUT_BM_SPLIT_PAGE_ID, domainName, referralAdditionalInfo);
    if (!canNavigate) {
      redirectionFallback();
    }
  },
  siteLevelRolesAndPermissions: metaSiteId => {
    return buildUrlWithParams(`/dashboard/${metaSiteId}/roles-and-permissions`, {
      referralAdditionalInfo: 'mydomains'
    });
  },
  businessManagerSettings: metaSiteId => {
    return buildUrlWithParams(`/dashboard/${metaSiteId}/settings`, {
      referralInfo: 'settings-breadcrumbs'
    });
  },
  businessManagerHome: (metaSiteId, referralAdditionalInfo) => {
    return buildUrlWithParams(`/dashboard/${metaSiteId}/home`, {
      referralAdditionalInfo
    });
  },
  businessManagerSetup: (metaSiteId, referralAdditionalInfo) => {
    return buildUrlWithParams(`/dashboard/${metaSiteId}/setup`, {
      referralAdditionalInfo
    });
  },
  multilingualSupportArticle: locale => `//support.wix.com/${locale}/article/wix-multilingual-about-multilingual-subdomains`,
  accountCountryLimitationSupportArticle: locale => `//support.wix.com/${locale}/article/wix-account-country-limitations`,
  domainInAnotherWixAccountSupportArticle: locale => `//support.wix.com/${locale}/article/moving-a-connected-domain-purchased-elsewhere-from-one-wix-account-to-another`,
  transferDomainToDifferentWixAccountSupportArticle: locale => `//support.wix.com/${locale}/article/transferring-your-wix-domain-to-a-different-wix-account`,
  myDomainsAccountLevel: () => '//manage.wix.com/account/domains',
  myDomainsSiteLevel: (msid, referralAdditionalInfo) => {
    return buildUrlWithParams(`/dashboard/${msid}/domain-settings`, {
      referralAdditionalInfo
    });
  },
  getRedemptionSuccessPage: domain => {
    return buildUrlWithParams('https://manage.wix.com/premium-success-pages/domain/redemption', {
      referrer: 'RedeemDomain',
      domainName: domain
    });
  },
  expressCheckoutBMPage: (domainName, msid) => {
    return buildUrlWithParams(`/dashboard/${msid}/premium-express-checkout-app`, {
      domainName
    });
  },
  connectDomainToWixSupportArticle: locale => buildUrlWithParams(`//support.wix.com/articles/id/e72873df-9108-4665-a12b-6b077e9d453f`, {
    locale
  }),
  packagePickerUrl: _ref10 => {
    let domainName = _ref10.domainName,
      metaSiteId = _ref10.metaSiteId,
      _ref10$referralAdditi = _ref10.referralAdditionalInfo,
      referralAdditionalInfo = _ref10$referralAdditi === void 0 ? DomainIntentReferral.CONNECT : _ref10$referralAdditi;
    const _parseDomain = parseDomain(domainName),
      asciiDomain = _parseDomain.asciiDomain;
    const searchParams = new URLSearchParams();
    if (metaSiteId) {
      searchParams.append('siteGuid', metaSiteId);
    }
    if (referralAdditionalInfo) {
      searchParams.append('referralAdditionalInfo', referralAdditionalInfo);
    }
    if (domainName) {
      searchParams.append('domainName', asciiDomain);
    }
    const query = searchParams.toString();
    return query ? `/wix/api/premiumStart?${query}` : `/wix/api/premiumStart`;
  },
  businessManager: (metaSiteId, referralAdditionalInfo) => {
    return buildUrlWithParams(`/dashboard/${metaSiteId}`, {
      referralAdditionalInfo
    });
  }
};
const navigateToExpressCheckoutBMApp = async (pageComponentId, domainName, referralAdditionalInfo) => {
  const api = window.BusinessManagerAPI;
  if (!api) {
    return false;
  }
  try {
    if (!api.isAppInstalled(EXPRESS_CHECKOUT_BM_APP_ID)) {
      await api.provisionApp(EXPRESS_CHECKOUT_BM_APP_ID);

      // sync problems with the installation of the app, requires some research why //
      await new Promise(resolve => {
        setTimeout(resolve, 200);
      });
    }
    api.navigateTo({
      pageComponentId,
      contextData: {
        appState: `?domainName=${domainName}&referralAdditionalInfo=${referralAdditionalInfo}`
      }
    });
    return true;
  } catch {
    return false;
  }
};
//# sourceMappingURL=urls.js.map